import s from './FilterGroup.module.scss';

export default function FilterGroup({ title, items, renderItem }) {
  return (
    <div className={s.wrapper}>
      <div className={s.title}>{title}</div>
      <ul className={s.list}>
        {items.map((item) => (
          <li key={item}>{renderItem(item)}</li>
        ))}
      </ul>
    </div>
  );
}
